<template>
    <div>
        <div class="row">
            <div class="col-12">
                <button class="btn btn-block text-gray-60 border-bottom mb-3 d-flex justify-content-between align-items-center" role="button" data-toggle="collapse" data-target="#collapseInfo" aria-expanded="true" aria-controls="collapseInfo">
                    {{ __("lang.kwl.basic.project_data") }}
                    <svg class="icon ml-auto">
                        <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                </button>
                <div class="collapse show" id="collapseInfo">
                    <ProjectDataComponent></ProjectDataComponent>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <button class="btn btn-block text-gray-60 border-bottom mb-3 d-flex justify-content-between align-items-center" role="button" data-toggle="collapse" data-target="#collapseBuildingType" aria-expanded="true" aria-controls="collapseBuildingType">
                    {{ __("lang.kwl.basic.building_data") }}
                    <svg class="icon ml-auto">
                        <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                </button>
                <div class="collapse show" id="collapseBuildingType">
                    <BuildingDataComponent></BuildingDataComponent>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <button class="btn btn-block text-gray-60 border-bottom mb-3 collapsed d-flex justify-content-between align-items-center" role="button" data-toggle="collapse" data-target="#collapseResult" aria-expanded="false" aria-controls="collapseResult">
                    {{ __("lang.kwl.basic.result") }}
                    <svg class="icon ml-auto">
                        <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                </button>
                <div class="collapse" :class="showResults ? 'show' : ''" id="collapseResult">
                    <ResultComponent></ResultComponent>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProjectDataComponent from "./ProjectDataComponent";
import BuildingDataComponent from "./BuildingDataComponent";
import ResultComponent from "./ResultComponent";

import Unit from "@models/building/Unit";

import log from "@services/logger/index";
import pageValidation from "@services/validations/pageValidation";

export default {
    components: {
        ProjectDataComponent,
        BuildingDataComponent,
        ResultComponent,
    },
    data() {
        return {};
    },
    methods: {},
    computed: {
        showResults() {
            var show = true;
            var units = Unit.query().all();

            units.forEach(function (unit) {
                if (isNaN(unit.moisureProtection) || unit.moisureProtection <= 0 || unit.moisureProtection == null) show = false;
                if (isNaN(unit.infiltration) || unit.infiltration <= 0 || unit.infiltration == null) show = false;
            });
            return show;
        },

        project: {
            get() {
                return this.$store.state.projectData.project;
            },
        },
    },
    watch: {
        project: {
            deep: true,
            handler() {
                pageValidation.validatePossiblePages();
            },
        },
    },
    mounted() {
        window.scrollTo(0, 0);
        document.getElementsByTagName("body")[0].classList.remove("is-loading");
    },
};
</script>
